module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-11"
    }
  }, [_c('h2', {
    staticClass: "chap_head"
  }, [_vm._v("THE FAR NORTH LINE, INVERNESS TO DINGWALL")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/11.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3. The Far")]), _vm._v(" North Line, between Inverness and Wick and Thurso, is the most northerly railway in Great Britain. The railway runs for 167 miles, including the branches to Wick and Thurso from Georgemas Junction.")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Locomotives 37030, 26038 and 26021 stand at Inverness depot. Birmingham Railway Carriage and Wagon Company (Birmingham RC&W) type 2 locomotives 26038 and 26021 were being prepared for the Inverness to Kyle of Lochalsh leg of F & W Railtours’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Skirl o’ the Pipes 4.")]), _vm._v(" These type 2 locomotives were fitted with Sulzer 6LDA28 engines of 1,160 hp. 12 May 1984.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/11_1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4. English Electric")]), _vm._v(" 37414 runs past Inverness Rose Street signal box. The Highland Stag emblem of Inverness Traction Maintenance Depot (TMD) is on the cabside of 37414, and the locomotive depot is in the background. Rose Street and Milburn Junction signal boxes controlled the lines bypassing Inverness station. 22 May 1986.")])])]), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/12.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5. British Rail")]), _vm._v(" diesel-electric locomotive 08717 shunts stock for a train to Wick and Thurso at Inverness station. These shunting locomotives were fitted with 400 hp English Electric engines. 30 May 1985.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/12_1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6. With a")]), _vm._v(" fine array of semaphore signals in evidence, Brush type 4 47210 approaches Inverness with a short, rush hour working from Invergordon. 31 May 1985.")])])]), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/13.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7. English Electric")]), _vm._v(" 37114 heads the 17.35 Inverness to Wick and Thurso over the swing bridge across the Caledonian Canal and past the signal box at Clachnaharry, Inverness. 30 May 1985.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/13_1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8. English Electric")]), _vm._v(" 37415 heads the 17.35 Inverness to Wick and Thurso over the River Ness Bridge, soon after leaving Inverness station. 1 June 1988.")])])]), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/14.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9. The crew")]), _vm._v(" of 37417 Highland Region pick up the token for the single line, as the 07.10 Kyle of\nLochalsh to Inverness passes the closed Lentran station, between Muir of Ord and Inverness. The station closed in 1960 and re-opened for a few days in 1982, while the canal bridge at Clachnaharry was repaired. 22 May 1986.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/14_1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10. Brush 47118")]), _vm._v(" arrives at Muir of Ord with an Invergordon to Inverness train. The Inverness and Ross-shire Railway signal box is on the left. These Brush type 4s were fitted with Sulzer 12LDA28-C engines of 2,580 hp. 27 May 1985.")])])]), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/15.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11. The signal")]), _vm._v(" arms have been removed as radio signalling takes over at Muir of Ord. English Electric 37414 departs with the 16.40 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hebridean Heritage")]), _vm._v(" from Kyle of Lochalsh to Inverness. Note the observation saloon behind the locomotive. 23 June 1988.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/15_1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12. English Electric")]), _vm._v(" 37017 heads through Dingwall with a loaded ballast train from Inverness to Brora. The McKenzie & Hollandbuilt signal box is in the background. The line to Kyle of Lochalsh diverges from the Far North Line at Dingwall. 27 May 1985.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55243bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/007_Chapter_1.vue
// module id = 78
// module chunks = 0